var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-wrapper",class:_vm.show ? 'visible' : ''},[_c('div',{staticClass:"spinner-overlay"}),_c('div',{staticClass:"spinner"},[_c('scaling-squares-spinner',{attrs:{"animation-duration":1250,"size":65,"color":"#059bf7"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }